import { render } from "./verifyAndAddPhone.vue?vue&type=template&id=75207b4a&ts=true"
import script from "./verifyAndAddPhone.vue?vue&type=script&lang=ts"
export * from "./verifyAndAddPhone.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__